{
	"default_pw": "$2b$10$Y6BW3brG7TZVTFgmbcHpTOIIAjM9G41kIMfQIiI6sN00jMHO4wLj.",
	"erp_mgr": {
		"account_name": "Macwill Information Systems",
		"bank_name": "Axis Bank Ltd.",
		"bank_branch": "Main Court Road, Hoshiarpur",
		"account_no": "919020082665734",
		"ifsc_code": "UTIB0000312",
		"email_id": "accounts@macwill.in",
		"phone_no": "8146617036",
		"office_address": "2nd Floor WD Complex, Court Road, Hoshiarpur, Punjab, India"
	}
}
